module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar-content"
  }, [(_vm.props) ? _c('div', {
    staticClass: "callouts2"
  }, [_c('a', {
    staticClass: "call_forms",
    attrs: {
      "href": "https://goo.gl/UIPSGY",
      "target": "_blank"
    }
  }, [_vm._v("Write a Review")]), _c('router-link', {
    staticClass: "call_forms",
    attrs: {
      "to": "/first-visit"
    }
  }, [_vm._v("New Patient Forms")]), _c('router-link', {
    staticClass: "call_app",
    attrs: {
      "to": "/appointment-request"
    }
  }, [_vm._v("Appointment Request   ")])], 1) : _vm._e(), _c('div', {
    staticClass: "r_links"
  }, [_c('a', {
    staticClass: "cp_reach",
    attrs: {
      "href": "http://www.myreachportal.com/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.props.acf.side_bars,
      "alt": "myreachportal"
    }
  })]), _c('a', {
    staticClass: "r_care",
    attrs: {
      "href": "http://www.carecredit.com/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.props.acf.side_bar1,
      "alt": "carecredit"
    }
  })]), _c('a', {
    staticClass: "r_banc",
    attrs: {
      "href": "https://www.orthobanc.com/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.props.acf.side_bar2,
      "alt": "orthobanc"
    }
  })]), _c('a', {
    staticClass: "r_review",
    attrs: {
      "href": "https://goo.gl/UIPSGY/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.props.acf.side_bar3,
      "alt": "goo"
    }
  })]), _c('a', {
    staticClass: "yelp",
    attrs: {
      "href": "https://www.yelp.com/biz/beaumont-orthodontics-beaumont",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.props.acf.side_bar4,
      "alt": "Beaumont Orthodontics",
      "width": "150",
      "height": "20"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ffd5816","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/sidebar/sidebar.pug
// module id = 597
// module chunks = 1